import { useState, useEffect } from "react";

const COLORS = {
  navy: "#003366",
  navyDark: "#001f44",
  navyMid: "#004080",
  red: "#cc0000",
  greyPage: "#f0f2f5",
  greyCard: "#e5e8ed",
  greyMid: "#c8cdd6",
  greyDark: "#555e6d",
  white: "#ffffff",
  textDark: "#1a2233",
  textMid: "#3d4a5c",
};

const IMAGES = {
  logoWhite: "https://arcuchicnc.com/wp-content/uploads/2023/07/Untitled-6.png",
  logoFooter: "https://arcuchicnc.com/wp-content/uploads/2023/07/Untitled-6.png",
  hydraulic: "https://arcuchicnc.com/wp-content/uploads/2025/08/HYDRAULIC.jpg",
  factory: "https://arcuchicnc.com/wp-content/uploads/2023/07/sdfds.jpg",
};

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return width;
}

// ─── Navbar ───────────────────────────────────────────────────────────────────
function ContactNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const w = useWindowWidth();
  const isMobile = w < 768;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Home", href: "/" },
    { label: "Solutions", href: "/#solutions" },
    { label: "Products", href: "/#products" },
    { label: "About", href: "#/about" },
    { label: "Services", href: "/#services" },
    { label: "News", href: "/#news" },
    { label: "Contact", href: "#/contact" },
  ];

  return (
    <>
      <nav style={{
        background: scrolled ? "rgba(0,31,68,0.97)" : COLORS.navyDark,
        backdropFilter: "blur(10px)",
        padding: isMobile ? "0 20px" : "0 40px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: 64, position: "sticky", top: 0, zIndex: 100,
        borderBottom: "1px solid rgba(204,0,0,0.25)", transition: "background 0.3s",
      }}>
        <a href="/" style={{ textDecoration: "none" }}>
          <img src={IMAGES.logoWhite} alt="Arcuchi" style={{ height: 36, objectFit: "contain" }} />
        </a>
        {!isMobile && (
          <div style={{ display: "flex", gap: 28, alignItems: "center" }}>
            {links.map(l => (
              <a key={l.label} href={l.href} style={{
                fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700,
                letterSpacing: "0.1em",
                color: l.label === "Contact" ? "#fff" : "rgba(255,255,255,0.65)",
                textDecoration: "none", textTransform: "uppercase", paddingBottom: 2,
                borderBottom: l.label === "Contact" ? `2px solid ${COLORS.red}` : "2px solid transparent",
                transition: "color 0.2s",
              }}>{l.label}</a>
            ))}
          </div>
        )}
        {!isMobile && (
          <a href="#/contact" style={{
            background: COLORS.red, color: "#fff", fontFamily: "Montserrat,sans-serif",
            fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "10px 22px", textDecoration: "none", display: "inline-block",
          }}>Get Quote</a>
        )}
        {isMobile && (
          <button onClick={() => setMenuOpen(o => !o)} style={{
            background: "none", border: "none", cursor: "pointer", padding: 4,
            display: "flex", flexDirection: "column", gap: 5,
          }}>
            {[0, 1, 2].map(i => (
              <span key={i} style={{
                display: "block", width: 24, height: 2, background: "#fff",
                transition: "transform 0.3s, opacity 0.3s",
                transform: menuOpen ? i === 0 ? "rotate(45deg) translate(5px,5px)" : i === 2 ? "rotate(-45deg) translate(5px,-5px)" : "none" : "none",
                opacity: menuOpen && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        )}
      </nav>
      {isMobile && (
        <div style={{
          position: "fixed", top: 64, left: 0, right: 0, zIndex: 99,
          background: COLORS.navyDark, maxHeight: menuOpen ? 400 : 0,
          overflow: "hidden", transition: "max-height 0.4s ease",
          borderBottom: menuOpen ? `2px solid ${COLORS.red}` : "none",
        }}>
          {links.map(l => (
            <a key={l.label} href={l.href} onClick={() => setMenuOpen(false)} style={{
              display: "block", padding: "14px 24px",
              fontFamily: "Montserrat,sans-serif", fontSize: 12, fontWeight: 700,
              color: l.label === "Contact" ? "#fff" : "rgba(255,255,255,0.65)",
              textDecoration: "none", textTransform: "uppercase", letterSpacing: "0.1em",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
            }}>{l.label}</a>
          ))}
        </div>
      )}
    </>
  );
}

// ─── Hero ─────────────────────────────────────────────────────────────────────
function ContactHero() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ position: "relative", overflow: "hidden", height: isMobile ? 280 : 360 }}>
      <img src={IMAGES.hydraulic} alt="Contact Arcuchi" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} />
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(110deg, rgba(0,15,40,0.94) 45%, rgba(0,30,70,0.6))" }} />
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "center", padding: isMobile ? "0 24px" : "0 80px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <div style={{ width: 36, height: 2, background: COLORS.red }} />
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>We're Here to Help</span>
        </div>
        <h1 style={{
          fontFamily: "Montserrat,sans-serif",
          fontSize: isMobile ? "clamp(28px,8vw,40px)" : "clamp(36px,4vw,52px)",
          fontWeight: 900, color: "#fff", textTransform: "uppercase",
          letterSpacing: "0.03em", lineHeight: 1.1, margin: 0,
        }}>
          Contact <span style={{ color: COLORS.red }}>Us</span>
        </h1>
        <p style={{ fontSize: isMobile ? 12 : 14, color: "rgba(255,255,255,0.6)", marginTop: 14, maxWidth: 460, lineHeight: 1.8, fontWeight: 300 }}>
          Whether you need a quote, technical support, or product information — our global team is available 24/7.
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 18, fontSize: 12, color: "rgba(255,255,255,0.4)", fontFamily: "Montserrat,sans-serif" }}>
          <a href="/" style={{ color: "rgba(255,255,255,0.4)", textDecoration: "none" }}>Home</a>
          <span>›</span>
          <span style={{ color: "#fff" }}>Contact</span>
        </div>
      </div>
    </section>
  );
}

// ─── Quick Info Bar ───────────────────────────────────────────────────────────
function QuickInfoBar() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const items = [
    { icon: "📞", label: "Call Us Anytime", value: "+86 138 2527 1417" },
    { icon: "✉️", label: "Email Us", value: "marketing@arcuchicnc.com" },
    { icon: "🕐", label: "Support Hours", value: "24 Hours / 7 Days a Week" },
    { icon: "📍", label: "Headquarters", value: "Shenzhen, Guangdong, China" },
  ];
  return (
    <div style={{ background: COLORS.red, display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4,1fr)" }}>
      {items.map((item, i) => (
        <div key={item.label} style={{
          padding: isMobile ? "16px 12px" : "22px 28px",
          borderRight: isMobile
            ? (i % 2 === 0 ? "1px solid rgba(255,255,255,0.2)" : "none")
            : (i < items.length - 1 ? "1px solid rgba(255,255,255,0.2)" : "none"),
          borderBottom: isMobile && i < 2 ? "1px solid rgba(255,255,255,0.15)" : "none",
          display: "flex", flexDirection: "column", alignItems: "center",
          textAlign: "center",
        }}>
          <span style={{ fontSize: isMobile ? 18 : 22, marginBottom: 6 }}>{item.icon}</span>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 8 : 9, fontWeight: 700, color: "rgba(255,255,255,0.75)", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 4 }}>{item.label}</div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 9.5 : 12, fontWeight: 700, color: "#fff", lineHeight: 1.4 }}>{item.value}</div>
        </div>
      ))}
    </div>
  );
}

// ─── Main Contact Section ─────────────────────────────────────────────────────
function MainContact() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", country: "", product: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => { e.preventDefault(); setSubmitted(true); };

  const inputStyle = {
    width: "100%", boxSizing: "border-box",
    background: COLORS.greyPage, border: `1px solid ${COLORS.greyMid}`,
    padding: "11px 14px", fontFamily: "Open Sans,sans-serif", fontSize: 13,
    color: COLORS.textDark, outline: "none", transition: "border-color 0.2s",
  };
  const labelStyle = {
    fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700,
    color: COLORS.navy, letterSpacing: "0.12em", textTransform: "uppercase",
    display: "block", marginBottom: 6,
  };

  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.white }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1.1fr", gap: isMobile ? 40 : 64 }}>

        {/* Left — Info */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Get in Touch</span>
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.5vw,30px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", lineHeight: 1.2, margin: "0 0 18px" }}>
            Let's Talk About <span style={{ color: COLORS.red }}>Your Project</span>
          </h2>
          <p style={{ fontSize: 13.5, color: COLORS.textMid, lineHeight: 1.85, marginBottom: 36 }}>
            Whether you need a standard IMM controller, a fully customized servo system, or expert support for your hydraulic press — our engineers are ready to deliver the right solution for your production line.
          </p>

          {/* Contact detail cards */}
          {[
            { icon: "📞", title: "Phone", lines: ["+86 138 2527 1417"] },
            { icon: "✉️", title: "Email", lines: ["marketing@arcuchicnc.com"] },
            { icon: "📍", title: "Headquarters", lines: ["Block A, Building 2, Shangzhi Technology Park", "No. 380 Guangming Ave, Tangwei Community", "Fenghuang Street, Guangming District, Shenzhen, China"] },
            { icon: "🕐", title: "Support", lines: ["24 Hours / 7 Days a Week", "Call Anytime — No Wait"] },
          ].map(({ icon, title, lines }) => (
            <div key={title} style={{ display: "flex", gap: 16, marginBottom: 22, paddingBottom: 22, borderBottom: `1px solid ${COLORS.greyCard}` }}>
              <div style={{ width: 44, height: 44, background: COLORS.navyDark, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 18, borderLeft: `3px solid ${COLORS.red}` }}>
                {icon}
              </div>
              <div>
                <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.greyDark, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 5 }}>{title}</div>
                {lines.map((l, i) => (
                  <div key={i} style={{ fontSize: 12.5, color: COLORS.textDark, lineHeight: 1.65 }}>{l}</div>
                ))}
              </div>
            </div>
          ))}

          {/* Social links */}
          <div style={{ marginTop: 8 }}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.greyDark, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 12 }}>Follow Us</div>
            <div style={{ display: "flex", gap: 10 }}>
              {[
                { label: "FB", href: "https://www.facebook.com/profile.php?id=100095303481787", color: "#1877F2" },
                { label: "TW", href: "https://twitter.com/arcuchi_cnc_10", color: "#1DA1F2" },
                { label: "IG", href: "https://www.instagram.com/arcuchicnc/", color: "#E1306C" },
                { label: "LI", href: "https://www.linkedin.com/in/arcuchi-cnc-50a672287/", color: "#0A66C2" },
              ].map(s => (
                <SocialBtn key={s.label} {...s} />
              ))}
            </div>
          </div>
        </div>

        {/* Right — Form */}
        <div style={{ background: COLORS.navyDark, padding: isMobile ? "24px 20px" : 40 }}>
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 8 }}>Leave a Message</div>
            <h3 style={{ fontFamily: "Montserrat,sans-serif", fontSize: 18, fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.04em", margin: 0 }}>
              Send Us a <span style={{ color: COLORS.red }}>Quote Request</span>
            </h3>
          </div>

          {submitted ? (
            <div style={{ textAlign: "center", padding: "48px 24px" }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 16, fontWeight: 800, color: "#fff", textTransform: "uppercase", marginBottom: 10 }}>Message Sent!</div>
              <p style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.75 }}>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
              <button onClick={() => setSubmitted(false)} style={{ marginTop: 20, background: COLORS.red, color: "#fff", fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", padding: "10px 24px", border: "none", cursor: "pointer" }}>Send Another</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 14, marginBottom: 14 }}>
                {[
                  { label: "Full Name *", name: "name", type: "text", placeholder: "Your full name", required: true },
                  { label: "Company", name: "company", type: "text", placeholder: "Company name" },
                  { label: "Email Address *", name: "email", type: "email", placeholder: "name@company.com", required: true },
                  { label: "Phone Number", name: "phone", type: "tel", placeholder: "+1 234 567 8900" },
                ].map(({ label, name, type, placeholder, required }) => (
                  <div key={name}>
                    <label style={{ ...labelStyle, color: "rgba(255,255,255,0.65)" }}>{label}</label>
                    <input
                      type={type} name={name} placeholder={placeholder}
                      value={form[name]} onChange={handleChange} required={required}
                      style={{ ...inputStyle, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", color: "#fff" }}
                      onFocus={e => e.target.style.borderColor = COLORS.red}
                      onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
                    />
                  </div>
                ))}
              </div>

              <div style={{ marginBottom: 14 }}>
                <label style={{ ...labelStyle, color: "rgba(255,255,255,0.65)" }}>Country / Region</label>
                <select name="country" value={form.country} onChange={handleChange}
                  style={{ ...inputStyle, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", color: form.country ? "#fff" : "rgba(255,255,255,0.4)", appearance: "none" }}>
                  <option value="">Select your country</option>
                  {["China","Mexico","Brazil","Turkey","Russia","Indonesia","Vietnam","Thailand","South Korea","Japan","India","Malaysia","Portugal","United States","Other"].map(c => (
                    <option key={c} style={{ color: COLORS.textDark, background: "#fff" }}>{c}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: 14 }}>
                <label style={{ ...labelStyle, color: "rgba(255,255,255,0.65)" }}>Product of Interest</label>
                <select name="product" value={form.product} onChange={handleChange}
                  style={{ ...inputStyle, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", color: form.product ? "#fff" : "rgba(255,255,255,0.4)", appearance: "none" }}>
                  <option value="">Select a product or service</option>
                  {["IMM Controller","Servo System","Frequency Converter","Machine Retrofit / Upgrade","Hydraulic Press Control","Wire Forming Control","Stamping Control","Annual Maintenance (AMC)","Technical Support","Other"].map(p => (
                    <option key={p} style={{ color: COLORS.textDark, background: "#fff" }}>{p}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={{ ...labelStyle, color: "rgba(255,255,255,0.65)" }}>Message / Requirements</label>
                <textarea
                  name="message" value={form.message} onChange={handleChange} rows={4}
                  placeholder="Describe your machine type, application, or specific requirements..."
                  style={{ ...inputStyle, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", color: "#fff", resize: "vertical" }}
                  onFocus={e => e.target.style.borderColor = COLORS.red}
                  onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
                />
              </div>

              <button type="submit" style={{
                width: "100%", background: COLORS.red, color: "#fff",
                fontFamily: "Montserrat,sans-serif", fontSize: 12, fontWeight: 700,
                letterSpacing: "0.12em", textTransform: "uppercase", padding: "15px 14px",
                border: "none", cursor: "pointer", transition: "background 0.2s",
              }}
                onMouseEnter={e => e.currentTarget.style.background = "#aa0000"}
                onMouseLeave={e => e.currentTarget.style.background = COLORS.red}
              >
                Send Message →
              </button>
              <p style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 12, textAlign: "center", lineHeight: 1.6 }}>
                We typically respond within 24 hours. Your information is kept confidential.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

function SocialBtn({ label, href, color }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a href={href} target="_blank" rel="noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: 38, height: 38, background: hovered ? color : COLORS.greyCard,
        display: "flex", alignItems: "center", justifyContent: "center",
        borderRadius: 2, fontSize: 11, fontFamily: "Montserrat,sans-serif",
        fontWeight: 800, color: hovered ? "#fff" : COLORS.greyDark,
        textDecoration: "none", transition: "background 0.2s, color 0.2s",
      }}>{label}</a>
  );
}

// ─── International Offices ────────────────────────────────────────────────────
function InternationalOffices() {
  const w = useWindowWidth();
  const isMobile = w < 768;

  const offices = [
    {
      country: "China (HQ)",
      flag: "🇨🇳",
      type: "Headquarters",
      typeColor: COLORS.red,
      company: "Shenzhen Arcuchi Technology Co., Ltd",
      address: "Block A, Building 2, Shangzhi Technology Park, No. 380 Guangming Ave, Tangwei Community, Fenghuang Street, Guangming District, Shenzhen",
      phone: "+86 138 2527 1417",
      email: "marketing@arcuchicnc.com",
      hours: "24/7",
    },
    {
      country: "Turkey",
      flag: "🇹🇷",
      type: "Authorized Distributor",
      typeColor: COLORS.navy,
      company: "MİKRO STAR Bilgisayar ve Elektronik Kontrol Sistemleri",
      address: "Istanbul, Turkey",
      phone: "(212) 278-8878",
      email: "info@mikrostar.com",
      hours: "Mon–Sat, 09:00–18:00",
    },
    {
      country: "Brazil",
      flag: "🇧🇷",
      type: "Regional Office",
      typeColor: COLORS.navyMid,
      company: "Arcuchi Brazil",
      address: "Rua Deonillo Zanella, Nº 101, Caxias do Sul – RS, Brazil",
      phone: "+55 (54) 99192-2241",
      email: "marketing@arcuchicnc.com",
      hours: "Mon–Fri, 08:00–17:00",
    },
    {
      country: "Mexico",
      flag: "🇲🇽",
      type: "Regional Office",
      typeColor: COLORS.navyMid,
      company: "Arcuchi Mexico",
      address: "Eje Oriente Poniente Manzana 5, Zona Industrial Tizayuca, Hidalgo, Mexico",
      phone: "+52 55 2314 9884",
      email: "marketing@arcuchicnc.com",
      hours: "Mon–Fri, 09:00–18:00",
    },
    {
      country: "India",
      flag: "🇮🇳",
      type: "Authorized Agents",
      typeColor: "#e67e22",
      company: "Multiple Agents",
      address: "Pan India Coverage",
      phone: "+91 8220108151 / +91 9879776327 / +91 9990979598",
      email: "marketing@arcuchicnc.com",
      hours: "Mon–Sat, 09:30–18:30",
    },
    {
      country: "Global",
      flag: "🌐",
      type: "International Support",
      typeColor: COLORS.greyDark,
      company: "Arcuchi Global Team",
      address: "Southeast Asia · Middle East · Europe · Americas",
      phone: "+86 138 2527 1417",
      email: "marketing@arcuchicnc.com",
      hours: "24/7 Remote Support",
    },
  ];

  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.greyPage }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 32 : 48 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Worldwide Network</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,32px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Our Global <span style={{ color: COLORS.red }}>Offices</span>
          </h2>
          <p style={{ fontSize: isMobile ? 13 : 13.5, color: COLORS.greyDark, marginTop: 10, maxWidth: 520, margin: "10px auto 0", lineHeight: 1.75 }}>
            With offices across 4 continents, our local teams provide on-the-ground support in your language and time zone.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3,1fr)", gap: isMobile ? 12 : 20 }}>
          {offices.map(o => <OfficeCard key={o.country} {...o} isMobile={isMobile} />)}
        </div>
      </div>
    </section>
  );
}

function OfficeCard({ country, flag, type, typeColor, company, address, phone, email, hours, isMobile }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? COLORS.navyDark : COLORS.white,
        padding: isMobile ? "16px 14px" : "28px 24px",
        boxShadow: hovered ? "0 16px 40px rgba(0,51,102,0.2)" : "0 2px 12px rgba(0,0,0,0.06)",
        transform: hovered ? "translateY(-4px)" : "none",
        transition: "all 0.3s", borderTop: `3px solid ${typeColor}`,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 8 : 10, marginBottom: isMobile ? 10 : 14 }}>
        <span style={{ fontSize: isMobile ? 20 : 26 }}>{flag}</span>
        <div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 11 : 13, fontWeight: 800, color: hovered ? "#fff" : COLORS.navy, textTransform: "uppercase", letterSpacing: "0.04em" }}>{country}</div>
          <span style={{
            display: "inline-block", marginTop: 3,
            background: typeColor, color: "#fff",
            fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 7.5 : 8.5, fontWeight: 700,
            letterSpacing: "0.08em", textTransform: "uppercase", padding: "2px 6px",
          }}>{type}</span>
        </div>
      </div>

      {!isMobile && (
        <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700, color: hovered ? "rgba(255,255,255,0.8)" : COLORS.greyDark, marginBottom: 12, fontStyle: "italic" }}>{company}</div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 7 : 9 }}>
        {[
          { icon: "📍", text: address },
          { icon: "📞", text: phone },
          !isMobile && { icon: "✉️", text: email },
          { icon: "🕐", text: hours },
        ].filter(Boolean).map(({ icon, text }) => (
          <div key={icon} style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
            <span style={{ fontSize: isMobile ? 10 : 12, flexShrink: 0, marginTop: 1 }}>{icon}</span>
            <span style={{ fontSize: isMobile ? 10 : 11.5, color: hovered ? "rgba(255,255,255,0.6)" : COLORS.greyDark, lineHeight: 1.5 }}>{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Map Section ──────────────────────────────────────────────────────────────
function MapSection() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ background: COLORS.navyDark }}>
      <div style={{ padding: isMobile ? "36px 24px 0" : "56px 80px 0", maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <div style={{ width: 32, height: 2, background: COLORS.red }} />
          <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,150,150,0.85)", letterSpacing: "0.22em", textTransform: "uppercase" }}>Find Us</span>
        </div>
        <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(20px,2.4vw,28px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em", marginBottom: 24 }}>
          Headquarters <span style={{ color: COLORS.red }}>Location</span>
        </h2>
      </div>
      <iframe
        title="Arcuchi Headquarters"
        src="https://maps.google.com/maps?q=Shangzhi+Technology+Park+No.380+Guangming+Avenue+Shenzhen&output=embed"
        width="100%"
        height={isMobile ? 280 : 380}
        style={{ border: "none", display: "block", filter: "grayscale(0.3) contrast(1.1)" }}
        loading="lazy"
      />
    </section>
  );
}

// ─── WhatsApp Float ───────────────────────────────────────────────────────────
function WhatsAppFloat() {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="https://wa.me/8613825271417"
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed", bottom: 28, right: 28, zIndex: 999,
        width: 56, height: 56, borderRadius: "50%",
        background: hovered ? "#128c3e" : "#25D366",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 4px 20px rgba(37,211,102,0.4)",
        transform: hovered ? "scale(1.1)" : "scale(1)",
        transition: "all 0.25s", textDecoration: "none",
      }}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.122 1.535 5.856L.057 23.142a.5.5 0 00.601.637l5.44-1.425A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.9a9.9 9.9 0 01-5.031-1.371l-.361-.213-3.737.979.997-3.645-.236-.375A9.86 9.86 0 012.1 12C2.1 6.533 6.533 2.1 12 2.1S21.9 6.533 21.9 12 17.467 21.9 12 21.9z"/>
      </svg>
    </a>
  );
}

// ─── FAQ Section ──────────────────────────────────────────────────────────────
function FAQ() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const [open, setOpen] = useState(null);
  const faqs = [
    { q: "How quickly can I get a quote?", a: "We respond to all quote requests within 24 hours on business days. For urgent inquiries, call our hotline at +86 138 2527 1417 — available 24/7." },
    { q: "Do you provide technical support after purchase?", a: "Yes. All products come with 1-year warranty and access to our 24/7 engineering support team via phone, video call, and remote diagnostics. AMC contracts are also available." },
    { q: "Can you retrofit our existing machines?", a: "Absolutely. Our retrofit solutions are designed to modernize legacy injection molding, hydraulic press, wire forming, and stamping machines with new Arcuchi control architecture and IoT connectivity." },
    { q: "Do you have agents in my country?", a: "We have distributors and agents in over 50 countries including Turkey, Brazil, Mexico, India, Vietnam, Indonesia, and more. Contact us with your location to connect with your nearest representative." },
    { q: "What machine types are your controllers compatible with?", a: "Our IMM controllers support injection molding machines; servo systems support hydraulic presses, wire benders, spring coilers, and stamping machines. We also offer frequency converters for variable-speed motor drives." },
    { q: "Is installation support included?", a: "Yes. Our engineers provide remote installation guidance for all products. For large-scale projects, on-site installation support can be arranged. Training is also available for your team." },
  ];
  return (
    <section style={{ padding: isMobile ? "40px 20px" : "80px 80px", background: COLORS.white }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
            <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: COLORS.red, letterSpacing: "0.22em", textTransform: "uppercase" }}>Common Questions</span>
            <div style={{ width: 32, height: 2, background: COLORS.red }} />
          </div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(22px,2.6vw,30px)", fontWeight: 800, color: COLORS.navy, textTransform: "uppercase", letterSpacing: "0.03em", margin: 0 }}>
            Frequently Asked <span style={{ color: COLORS.red }}>Questions</span>
          </h2>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {faqs.map((faq, i) => (
            <FAQItem key={i} {...faq} isOpen={open === i} onToggle={() => setOpen(open === i ? null : i)} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ q, a, isOpen, onToggle }) {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <div style={{ border: `1px solid ${isOpen ? COLORS.red : COLORS.greyMid}`, transition: "border-color 0.2s" }}>
      <button onClick={onToggle} style={{
        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: isMobile ? "14px 16px" : "18px 22px",
        background: isOpen ? COLORS.navyDark : COLORS.white,
        border: "none", cursor: "pointer", textAlign: "left", transition: "background 0.2s",
      }}>
        <span style={{ fontFamily: "Montserrat,sans-serif", fontSize: isMobile ? 11.5 : 13, fontWeight: 700, color: isOpen ? "#fff" : COLORS.navy, textTransform: "uppercase", letterSpacing: "0.02em", paddingRight: 12, lineHeight: 1.4 }}>{q}</span>
        <span style={{ fontSize: 18, color: isOpen ? COLORS.red : COLORS.greyDark, flexShrink: 0, transition: "transform 0.25s", display: "inline-block", transform: isOpen ? "rotate(45deg)" : "none" }}>+</span>
      </button>
      {isOpen && (
        <div style={{ padding: isMobile ? "14px 16px 18px" : "16px 22px 20px", background: COLORS.greyPage, borderTop: `1px solid ${COLORS.greyMid}` }}>
          <p style={{ fontSize: isMobile ? 12 : 13, color: COLORS.textMid, lineHeight: 1.85 }}>{a}</p>
        </div>
      )}
    </div>
  );
}

// ─── CTA Banner ───────────────────────────────────────────────────────────────
function ContactCTA() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  return (
    <section style={{ background: COLORS.red, padding: isMobile ? "48px 24px" : "60px 80px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto", display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", justifyContent: "space-between", gap: 28 }}>
        <div>
          <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,0.75)", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 8 }}>Ready to Get Started?</div>
          <h2 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "clamp(20px,2.4vw,28px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", letterSpacing: "0.03em", margin: 0, lineHeight: 1.2 }}>
            Talk to an Engineer Today
          </h2>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.8)", marginTop: 8, lineHeight: 1.7 }}>
            Available 24/7 — call us directly or send a message and we'll respond within 24 hours.
          </p>
        </div>
        <div style={{ display: "flex", gap: 14, flexShrink: 0, flexWrap: "wrap", width: isMobile ? "100%" : "auto" }}>
          <a href="tel:+8613825271417" style={{
            background: "#fff", color: COLORS.red, fontFamily: "Montserrat,sans-serif",
            fontSize: 12, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase",
            padding: "13px 26px", textDecoration: "none", display: "block",
            textAlign: "center", flex: isMobile ? 1 : "none",
          }}>📞 Call Now</a>
          <a href="https://wa.me/8613825271417" target="_blank" rel="noreferrer" style={{
            background: "transparent", color: "#fff", fontFamily: "Montserrat,sans-serif",
            fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase",
            padding: "12px 22px", border: "2px solid rgba(255,255,255,0.6)",
            textDecoration: "none", display: "block",
            textAlign: "center", flex: isMobile ? 1 : "none",
          }}>💬 WhatsApp</a>
        </div>
      </div>
    </section>
  );
}

// ─── Footer ───────────────────────────────────────────────────────────────────
function ContactFooter() {
  const w = useWindowWidth();
  const isMobile = w < 768;
  const cols = [
    { title: "Products", links: ["IMM Controller","Servo System","Frequency Converter","Retrofit Kits"] },
    { title: "Company", links: ["About Us","News & Events","Blogs","Careers"] },
    { title: "Support", links: ["Contact Us","Technical Docs","AMC Program","WhatsApp Chat"] },
  ];
  return (
    <footer style={{ background: COLORS.navyDark, padding: isMobile ? "40px 20px 20px" : "48px 80px 24px" }}>
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "2fr 1fr 1fr 1fr", gap: isMobile ? 28 : 40, marginBottom: 40 }}>
        <div style={{ gridColumn: isMobile ? "1 / -1" : "auto" }}>
          <img src={IMAGES.logoFooter} alt="Arcuchi" style={{ height: 40, objectFit: "contain", marginBottom: 14, display: "block" }} />
          <p style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", lineHeight: 1.8, maxWidth: 260, fontWeight: 300 }}>
            Enhance your production efficiency with advanced controllers and servos for various industrial equipment worldwide.
          </p>
        </div>
        {cols.map(col => (
          <div key={col.title}>
            <div style={{ fontFamily: "Montserrat,sans-serif", fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.8)", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 14, paddingBottom: 8, borderBottom: `1px solid ${COLORS.red}` }}>
              {col.title}
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8 }}>
              {col.links.map(l => <li key={l}><a href="#" style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>{l}</a></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: 20, display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: "center", gap: isMobile ? 14 : 0 }}>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", textAlign: isMobile ? "center" : "left" }}>
          © 2025 Shenzhen Arcuchi Technology Co., Ltd. All rights reserved.
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {[["FB","https://www.facebook.com/profile.php?id=100095303481787"],["TW","https://twitter.com/arcuchi_cnc_10"],["IG","https://www.instagram.com/arcuchicnc/"],["LI","https://www.linkedin.com/in/arcuchi-cnc-50a672287/"]].map(([label, href]) => (
            <a key={label} href={href} target="_blank" rel="noreferrer" style={{ width: 30, height: 30, background: "rgba(255,255,255,0.07)", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 2, fontSize: 10, fontFamily: "Montserrat,sans-serif", fontWeight: 700, color: "rgba(255,255,255,0.45)", textDecoration: "none" }}>
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

// ─── Contact Page Root ────────────────────────────────────────────────────────
export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact Us — Arcuchi CNC";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800;900&family=Open+Sans:wght@300;400;600&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Open Sans', sans-serif; background: #f0f2f5; color: #1a2233; }
        html { scroll-behavior: smooth; }
      `}</style>
      <ContactNavbar />
      <ContactHero />
      <QuickInfoBar />
      <MainContact />
      <InternationalOffices />
      <MapSection />
      <FAQ />
      <ContactCTA />
      <ContactFooter />
      <WhatsAppFloat />
    </>
  );
}
